@if (media) {
  <sd-banner [media]="media" />
}
<sd-html
  innerClass="c__content {{horizontalParentLayout ? 'is-overline' : 'is-body-s'}}"
  [html]="description"
/>
